import React from 'react'
import {Link} from 'react-router-dom'
import childDefaultImage from 'assets/img/defaults/profile_default_v01.png'

const styles ={
  hideOverflow: {
    overflow: 'hidden'
  },
  childPortrait: {
    transform: 'translateX(-50%)',
    marginLeft: '50%'
  }
}

const MyChildMain = props => {
  return (
    <div className="island">
      <h2>{props.heading} {props.child.given_name}</h2>

      <div className="child-greeting">
        {props.child.paragraph_body}
      </div>

      <div className="child-portrait" style={styles.hideOverflow}>
        <img src={props.childPhoto || childDefaultImage} alt="" style={styles.childPortrait}/>
      </div>

      <Link to={`/dashboard/child/${props.child.child_id}`} className="btn">Learn more</Link>
    </div>
  )
}

MyChildMain.defaultProps = {
  heading: 'About',
  child: {
    name: '',
    paragraph_body: ''
  },
  childPhoto: childDefaultImage
}

export default MyChildMain
